
import {
    DotCell, DotCellStates,
} from 'components/Table/cellComponents'

import {
    buttonIcon,
    queueButton, queueButtonInner,
} from './styles'

import Button from 'components/Button'
import {ButtonProps} from 'components/Button/types'
import {FormState} from 'components/Embed/EmbedQuestionnaire'
import {Icon} from 'components/Icon/types'
import React from 'react'


import {replaceVariables} from '../helpers'
import {styled} from '@stitches/react'
import {useAppSelector} from 'hooks'

const StyledQueueButton = styled('div', queueButton)
const StyledQueueButtonInner = styled('div', queueButtonInner)
const StyledIcon = styled('div', buttonIcon)

export interface QuestionnaireQueueButtonProps {
    align?: 'right' | 'center' | 'left'
    target: string
    text: string
    queue_id: string,
    maxWidth?: string,
    textAlign?: 'left' | 'right' | 'center'
    inline?: boolean
    padding?: string
    text_closed?: string
    questionnaireValues: Record<string, string>
    formState: FormState
    variant?: 'primary' | 'secondary' | 'tertiary',
    iconLeft?: {
        src?: string
        svg?: string
    },
    iconRight?: {
        src?: string
        svg?: string
    }
    onClick: (queue_id: string, target: string) => void
}

export const QuestionnaireQueueButton = (props: QuestionnaireQueueButtonProps) => {
    const {
        align, textAlign, inline, text, questionnaireValues,
        formState, onClick, queue_id, text_closed, target,
        iconLeft, iconRight,
        maxWidth, padding, variant, ...other
    } = props

    const audienceQueues = useAppSelector(({ninchat}) => {
        const realmQueues = ninchat._user_realm_queues
        return Object.keys(realmQueues).map((id) => ({
            ...realmQueues[id],
            queue_id: id,
        }))
    })

    const getQueueName = (queueId: string) => {
        const queue = audienceQueues.find((q) => q.queue_id === queueId)
        return queue?.queue_attrs.name
    }

    const isQueueClosed = (queueId: string) => {
        const queue = audienceQueues.find((q) => q.queue_id === queueId)

        if (queue) {
            return queue.queue_attrs.closed || queue.queue_attrs.suspended
        }

        return true
    }

    const values = {
        ...questionnaireValues,
        queue_name: getQueueName(queue_id) || '',
    }

    // eslint-disable-next-line no-undef-init
    let color: ButtonProps['color'] = undefined
    if (variant === 'primary') {
        color = 'filled'
    } else if (variant === 'tertiary') {
        color = 'text'
    }

    const iconLeftSelected = () => {
        if (iconLeft?.svg) {
            // eslint-disable-next-line react/no-danger
            return <StyledIcon aria-hidden='true' dangerouslySetInnerHTML={{__html: iconLeft?.svg}} />
        } else if (iconLeft?.src) {
            return <img aria-hidden='true' src={iconLeft?.src} />
        } else if (iconLeft) {
            return null
        }
        // eslint-disable-next-line no-negated-condition
        return <DotCell state={!isQueueClosed(queue_id) ? DotCellStates.positive : DotCellStates.negative} />
    }

    const iconRightSelected = () => {
        if (iconRight?.svg) {
            // eslint-disable-next-line react/no-danger
            return <StyledIcon aria-hidden='true' dangerouslySetInnerHTML={{__html: iconRight?.svg}} />
        } else if (iconRight?.src) {
            return <img aria-hidden='true' src={iconRight?.src} />
        }
        return null
    }

    return (
        <StyledQueueButton align={align} inline={inline} textAlign={textAlign}>
            <StyledQueueButtonInner css={{maxWidth}} >
                <Button
                    color={color}
                    css={{'&&': {padding}}}
                    disabled={isQueueClosed(queue_id)}
                    // eslint-disable-next-line react/no-unstable-nested-components, no-negated-condition
                    iconLeft={iconLeftSelected as unknown as Icon}
                    // eslint-disable-next-line no-negated-condition
                    iconRight={iconRightSelected as unknown as Icon}
                    multiline={true}
                    onPress={() => onClick(queue_id, target)}
                    text={isQueueClosed(queue_id) ? replaceVariables(text_closed || '', values, formState) : replaceVariables(text || '', values, formState)}
                    {...other}
                />
            </StyledQueueButtonInner>
        </StyledQueueButton>
    )
}

QuestionnaireQueueButton.defaultProps = {
    align: null,
    iconLeft: undefined,
    iconRight: undefined,
    inline: false,
    maxWidth: undefined,
    padding: undefined,
    textAlign: '',
    text_closed: '',
    variant: 'secondary',
}
